import DynamicFormModelBase from '../_generated/modelBases/dynamic-form-model-base';

export default class DynamicFormModel extends DynamicFormModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
